export const SWAP_PROGRESS_STATUS = {
  SWAP_IN_PROGRESS: "in_progress",
  SWAP_COMPLETED: "swap_complete",
  SWAP_INCOMPLETE: "swap_incomplete",
  SWAP_PENDING: "swap_pending",
  SWAP_FAILED: "swap_failed",
  SWAP_ACTIVE: "swap_active",
  ERROR: "error",
};

export const EXPECTED_SWAP_STATUS = [
  "swap_complete",
  "swap_incomplete",
  "swap_pending",
];

export const ORG_DEVICE_CONFIG = {
  Electriva: [
    {
      partnerId: "ELECTRIVA-IND-02",
      partnerName: "Electriva IND2W-2",
      deviceId: "866557054044740",
    },
    {
      partnerId: "ELECTRIVA-IND-01",
      partnerName: "Electriva IND2W-1",
      deviceId: "866557054205945",
    },
    {
      partnerId: "ELECTRIVA-IND-01C",
      partnerName: "Electriva IND2W-3",
      deviceId: "866557054308467",
    },
    {
      partnerId: "ELECTRIVA-IND-01D",
      partnerName: "Electriva IND2W-4",
      deviceId: "869531072335379",
    },
  ],
};
